define([
        "dojo/_base/lang",
        "../../../constants/TypeConstants",
        "../properties/TypeProperty",
        "../properties/TagProperty",
        "../properties/QuickAccessIconProperty",
        "../properties/TextProperty",
        "../properties/TextOverrideProperty",
        "../properties/EnabledProperty",
        "../properties/DescriptionProperty",
        "../properties/DescriptionOverrideProperty",
        "../properties/MnemonicProperty",
        "../properties/ShortcutProperty",
        "../properties/ActionIdProperty",
        "../properties/IsInQABProperty",
        "../properties/PopupIdProperty",
        "../properties/HasDynamicPopupProperty",
        "../properties/ShowTextProperty"

    ],
    function (lang, TypeConstants, TypeProperty, TagProperty, QuickAccessIconProperty,
              TextProperty, TextOverrideProperty, EnabledProperty, DescriptionProperty,
              DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty, IsInQABProperty,
              PopupIdProperty, HasDynamicPopupProperty, ShowTextProperty) {
        var hash = {};

        hash[TypeConstants.QAB_FLOATING_PANE_DOCK] = lang.mixin({}, TypeProperty, TagProperty,
            QuickAccessIconProperty,  TextProperty, TextOverrideProperty, EnabledProperty,
            DescriptionProperty, DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty,
            IsInQABProperty, PopupIdProperty, HasDynamicPopupProperty, ShowTextProperty);

        return hash;
    });

